<template>
  <div class="home-general-container">
    <div class="home-left-container">
      <Mosaic/>
    </div>
    <div class="home-right-container">
      <div class="content">
        <div class="medium-font">Cartografía de la</div>
        <div class="big-font">Literatura</div>
        <div class="big-font">Digital</div>
        <!-- <div class="medium-font">en</div> -->
        <div class="big-font">Latinoamericana</div>
        <!-- <div class="big-font">Latina</div> -->
        <div id="padded" class="small-font">Visualización, archivo y preservación</div>
        <div class="small-font">de obras literarias digitales</div>
        <router-link to="/map">
          <button
            class="map-button"
            :style="buttonStyle">Entrar</button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Mosaic from '../components/home/Mosaic.vue'

export default {
  name: 'Home',  
  components: {
    Mosaic,
  },
  metaInfo: {
    title: 'Cartografía Digital',
    titleTemplate: null,
    htmlAttrs: {
      lang: 'es'
    },
    meta: [
      { charset: 'utf-8' },
      {
        name: 'description',
        content: 'Cartografía Digital de la Literatura Latinoamericana | Visualización, archivo y preservación de obras digitales'
      },
      {
        property: 'og:title',
        content: 'Cartografía Digital',
        vmid: 'og:title',
      },
      {
        property: 'og:description',
        content: 'Cartografía Digital de la Literatura Latinoamericana | Visualización, archivo y preservación de obras digitales',
        vmid: 'og:description',
      },
      {
        property: 'og:url',
        content: 'https://www.cartografiadigital.cl/',
        vmid: 'og:url',
      },
      {
        property: 'og:type',
        content: 'website',
        vmid: 'og:type',
      },
      {
        property: 'twitter:card',
        content: 'summary',
        vmid: 'twitter:card',
      },
      {
        property: 'twitter:site',
        content: 'https://www.cartografiadigital.cl',
        vmid: 'twitter:site',
      },
      {
        property: 'twitter:title',
        content: 'Cartografía Digital',
        vmid: 'twitter:title',
      },
      {
        property: 'twitter:description',
        content: 'Cartografía Digital de la Literatura Latinoamericana | Visualización, archivo y preservación de obras digitales',
        vmid: 'twitter:description',
      }
    ]
  },
  data(){
    return {
      buttonStyle: {
        width: 0,
        height: 0,
      }
    }
  },
  mounted() {
    const clientWidth = this.$el.clientWidth;
    const w = clientWidth / 5 * 2 / 10;
    this.buttonStyle.width = `${w + 8}px`
    this.buttonStyle.height = `${w * 4 / 5}px`;
  }

}
</script>

<style scoped>

  .home-general-container {
    display: grid;
    grid-template-columns: 2fr 3fr;
    height: 100%;
    width: 100%;
    color: var(--black);
  }

  .home-left-container {
    grid-column: 1 / 2;
    width: 100%;
  }

  .home-right-container {
    grid-column: 2 / 3;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .big-font {
    font-family: var(--vesper);
    font-size: 40px;
    line-height: 44px;
    font-weight: 900;
    text-transform: uppercase;
  }

  .medium-font {
    font-family: var(--vesper);
    font-size: 40px;
    font-weight: 500;
    line-height: 44px;
  }

  .small-font {
    font-family: var(--vesper);
    font-size: 24px;
    font-weight: 500;
    line-height: 28px;
    width: 390px;
  }

  .content div {
    padding: 0;
    margin: 0;
  }

  .map-button {
    margin-top: 12px;
    color: white;
    background-color: var(--black);
    font-family: var(--courier);
  }

  #padded {
    margin-top: 30px;
  }

</style>